export default "__VITE_ASSET__C06aL6HO__"